var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 2.85026H15.25V1.18359H13.5833V2.85026H6.91667V1.18359H5.25V2.85026H4.41667C3.49167 2.85026 2.75833 3.60026 2.75833 4.51693L2.75 16.1836C2.75 17.1003 3.49167 17.8503 4.41667 17.8503H16.0833C17 17.8503 17.75 17.1003 17.75 16.1836V4.51693C17.75 3.60026 17 2.85026 16.0833 2.85026ZM16.0833 16.1836H4.41667V7.01693H16.0833V16.1836ZM6.08333 8.68359H10.25V12.8503H6.08333V8.68359Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar-today.12a8e4dc40bf8d1a363f466970b10d22.svg";
export { ForwardRef as ReactComponent };